import React, { useEffect, useState } from "react";
import get from "lodash/get";

import { AdContainer } from "../../ads";
import { filterStory } from "../../helper/api";
import CollectionTitleHeader from "../../molecules/collection-title-header";
import Separator from "../../atoms/separator";
import StoryCard5 from "../../molecules/story-card5";
import StoryCard6 from "../../molecules/story-card6";

import "./seven-stories.m.css";

const SevenStories = ({ collection, index, page }) => {
  if (!collection && !collection?.items) {
    return null;
  }

  const stories = page === "not-found" ? collection.items : filterStory(collection);

  const [isMobile, setMobile] = useState(false);

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);

  if (!stories) {
    return null;
  }

  const AdCard = ({ id, mobile }) => {
    if (index !== 1) return null;
    return (
      <>
        {isMobile ? (
          <div styleName="ad-wrapper" className="hide-desktop">
            <AdContainer AdClassName="standard-336x280" id={id} mobile={mobile} />
          </div>
        ) : null}
      </>
    );
  };

  const desktopAdUnitId = get(collection, ["associated-metadata", "desktopAdUnitId"], null);
  const mobileAdUnitId1 = get(collection, ["associated-metadata", "mobileAdUnitId1"], null);
  const mobileAdUnitId2 = get(collection, ["associated-metadata", "mobileAdUnitId2"], null);
  const mobileAdUnitId3 = get(collection, ["associated-metadata", "mobileAdUnitId3"], null);

  return (
    <>
      <CollectionTitleHeader collection={collection} index={index} />
      <div styleName="border-wrapper">
        <div styleName="wrapper">
          <div styleName="col1">
            {stories?.splice(0, 1).map((item, index) => (
              <StoryCard5 story={item} key={item.id} />
            ))}
          </div>
          <div styleName="col2 col2-wrapper">
            {stories?.splice(0, 3).map((item, index) => (
              <React.Fragment key={item.id}>
                <StoryCard6 story={item} key={item.id} headerType={4} />
                {index === 1 && <AdCard id="div-gpt-ad-1680156938221-0" mobile={mobileAdUnitId1} />}
              </React.Fragment>
            ))}
          </div>
          {!isMobile && (
            <div styleName="col2">
              {stories?.splice(0, 1).map((item, index) => (
                <StoryCard6 story={item} key={item.id} headerType={4} />
              ))}
              {desktopAdUnitId ? (
                <div styleName="ad-wrapper">
                  <AdContainer
                    AdClassName="standard-336x280"
                    id="div-gpt-ad-1680156228599-0"
                    desktop={desktopAdUnitId}
                  />
                </div>
              ) : (
                stories?.splice(0, isMobile ? 4 : 2).map((item, index) => {
                  return <StoryCard6 story={item} key={index} headerType={4} />;
                })
              )}
            </div>
          )}
          {isMobile ? (
            <>
              <div styleName="col2 col2-wrapper">
                {stories?.splice(0, 7).map((item, index) => (
                  <React.Fragment key={item.id}>
                    <StoryCard6 story={item} key={item.id} headerType={4} />
                    {index === 2 && <AdCard id="div-gpt-ad-16758373692061-1" mobile={mobileAdUnitId2} />}
                    {index === 6 && <AdCard id="div-gpt-ad-1680156998073-0" mobile={mobileAdUnitId3} />}
                  </React.Fragment>
                ))}
              </div>
            </>
          ) : null}
        </div>
        <Separator />
      </div>
    </>
  );
};

export default SevenStories;
